import type { SchemaBuilderDndHandleProps } from "./schema-builder-dnd-handle.type";

import classNames from "classnames";

import "./schema-builder-dnd-handle.style.less";

export const SchemaBuilderDndHandle = ({
  className,
  style,
  ...dndProps
}: SchemaBuilderDndHandleProps) => {
  return (
    <div
      className={classNames("schema-builder-dnd-handle", className)}
      style={style}
      {...dndProps}
    >
      <svg
        width="11"
        height="16"
        viewBox="0 0 11 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="2" cy="2" r="2" fill="#C4C4C4" />
        <circle cx="9" cy="2" r="2" fill="#C4C4C4" />
        <circle cx="2" cy="8" r="2" fill="#C4C4C4" />
        <circle cx="2" cy="14" r="2" fill="#C4C4C4" />
        <circle cx="9" cy="8" r="2" fill="#C4C4C4" />
        <circle cx="9" cy="14" r="2" fill="#C4C4C4" />
      </svg>
    </div>
  );
};
